module.exports = __webpack_public_path__ + "img/warning.b61b5d8.png";